@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/scss/mixins';

$btnWidth: 32px;
$labelWidthDefault: 160px;

:host {
  width: $labelWidthDefault;
  position: relative;
}

.dropdown {
  color: var(--body-text-arrows-400);
  font-size: var(--body-size);
  height: calc(4 * var(--spacer));
  transition: all 0.3s ease;

  &.label-width-full {
    width: 100%;
  }

  &:hover {
    .dropdown-label {
      border-color: var(--body-text-arrows-400);
    }
  }
}

.dropdown-label {
  height: 100%;
  padding: 0 0 0 var(--input-padding-left);
  line-height: 1;
  border-radius: var(--input-border-radius);
  border-top: var(--dropdown-border-top, 1px solid var(--chart-100-pressed));
  border-bottom: var(--dropdown-border-bottom, 1px solid var(--chart-100-pressed));
  border-left: var(--dropdown-border-left, 1px solid var(--chart-100-pressed));
  border-right: var(--dropdown-border-right, 1px solid var(--chart-100-pressed));
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  background: var(--white-layout-301-level-0-elevation);
  font-family: var(--font-family-secondary);

  &-main {
    --floating-label-margin-left: calc(var(--spacer) / -2);
    transition: var(--floating-label-transition);
    font-family: var(--font-family-secondary);
  }

  .dropdown-label-main {
    color: var(--body-text-arrows-400);
  }

  &--value {
    padding: calc(var(--spacer) / 2) 0;
    height: 100%;
    width: calc(100% - #{$btnWidth});
    outline: none;
    border: none;
    box-shadow: none;
    color: var(--body-text-arrows-400);
    white-space: nowrap;
    overflow: hidden;
    line-height: 1.8;
    font-size: var(--body-size);
    display: inline-flex;
    align-items: center;
  }

  &--secondary-label {
    color: var(--body-text-arrows-400);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    font-family: var(--font-family-secondary);
  }

  &--placeholder {
    color: var(--chart-300-icon-buttons);
    font-style: italic;
    font-family: var(--font-family-secondary);
  }

  &.has-label {
    .dropdown-label--placeholder {
      display: none;
    }
  }
}

:host(.invalid) {
  .dropdown-label {
    border-color: var(--red-layout-300-primary);
  }
}

.clear-button {
  height: auto;
  display: var(--delete-button-visiblity, block);
}

.dropdown-button {
  min-width: $btnWidth;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: transparent;
  color: var(--chart-300-icon-buttons);
  margin: 0;
  border-top-right-radius: var(--input-border-radius);
  border-bottom-right-radius: var(--input-border-radius);

  .icon {
    font-size: 16px;
  }

  .ds-icon {
    font-size: 20px;
  }

  .error-icon {
    color: var(--red-layout-300-primary);
    font-size: calc(3 * var(--spacer));
  }

  &:not(.custom-icon) {
    &:hover {
      background-color: var(--chart-050-hover);
    }

    &:active {
      background-color: var(--chart-102-pressed);
      .dropdown-arrow {
        border-top-color: var(--chart-300-icon-buttons);
      }
    }

  }
}

.dropdown-arrow {
  display: inline-block;
  vertical-align: middle;
  position: absolute;
  right: 0;
  left: 0;
  margin: 0 auto;
  top: calc(50% - 2px);
  width: 10px;
  height: 10px;
  border-top: solid 5px var(--chart-302-icon-buttons-titles);
  border-left: solid 5px transparent;
  border-right: solid 5px transparent;
}

.dropdown-menu {
  display: none;
  visibility: hidden;
  transition: visibility 0.5s;
  overflow: hidden;
  min-width: var(--dropdown-min-width, 240px);
  width: var(--dropdown-width, auto);
  max-width: var(--dropdown-max-width, none);
  position: absolute;
  z-index: 9999;
  top: calc(var(--spacer) * 5);
  border-radius: var(--dropdown-border-radius, var(--input-border-radius));
  border: 1px solid var(--chart-101-pressed-dividers);
  background-color: var(--white-layout-301-level-0-elevation);
  color: var(--main-titles-inputs-600);
  font-size: var(--body-size-large);
}

.datetime-filter {
  &--wrapper {
    padding: 20px;
  }
}

.default-filter {
  &--wrapper {
    padding: 20px;
  }
}

:host([menuPosition='right']) {
  .dropdown-menu {
    right: 0;
  }
}

:host([menuPosition='center']) {
  .dropdown-menu {
    right: 0;
  }
}

.dropdown-label.has-label {
  .has-value {
    @include floating-label(-60%);
  }
}


:host([open]),
:host(:active),
:host(:focus-within) {
  .dropdown-label.has-label {
    .has-placeholder {
      @include floating-label(-60%);
      color: var(--blue-layout-301-active);
    }

    &.has-label {
      .dropdown-label--placeholder {
        display: block;
      }
    }
  }
}

:host([open]),
:host(:active) {
  .dropdown {
    .dropdown-label {
      border-color: var(--blue-layout-301-active);
      border-radius: var(--dropdown-active-border-radius, var(--input-border-radius));

      &--placeholder {
        display: block;
      }

      &-main {
        color: var(--blue-layout-301-active);
      }
    }
  }
}

:host(:focus-within) {
  .dropdown-label {
    border-color: var(--blue-layout-500-focus);

    &--placeholder {
      display: block;
    }

    &-main {
      color: var(--blue-layout-500-focus);
    }
  }
}

:host([open]) {
  .dropdown-menu {
    display: block;
    visibility: visible;
    transition: visibility 0.5s;
    border-color: var(--blue-layout-301-active);
  }
}

:host([isError]) {
  .dropdown {
    .dropdown-label {
      border-color: var(--red-layout-300-primary);
    }
  }

  .dropdown-label .dropdown-label-main {
    color: var(--red-layout-300-primary);
  }

  .dropdown-menu {
    border-color: var(--red-layout-300-primary);
  }
}

:host([readonly]) {
  &:host(:active) {
    .dropdown-label .dropdown-label-main {
      color: var(--body-text-arrows-400);
    }
  }

  .dropdown {
    .dropdown-label {
      pointer-events: none;
      background-color: var(--chart-050-hover);
      border-color: transparent;

      .has-value {
        &:before {
          background: transparent;
        }
      }
    }
    .dropdown-arrow {
      border-top-color: var(--grey-layout-200-disabled);
    }
  }
}

$labelWidths: 80, 160, 240, 320, 400;
$labelWidthFull: 100%;
$labelWidthAuto: auto;

@each $size in $labelWidths {
  :host([labelWidth='#{$size}']) {
    width: #{$size}px;
  }
}

:host([labelWidth='full']) {
  width: $labelWidthFull;
}

:host([labelWidth='auto']) {
  width: $labelWidthAuto;
  display: inline-block;
}

:host([labelWidth='80']),
:host([labelWidth='auto']) {
  .dropdown-label {
    &-main {
      position: initial;
    }
  }
}

:host([open][labelWidth='auto']),
:host([open][labelWidth='80']) {
  .dropdown-label {
    &-main {
      transform: translateY(-93.5%);
    }

    &--value {
      overflow: visible;
    }
  }
}
